import { inject } from "@angular/core";
import { AuthorizationResult, authGuardWithActionFnFactory } from "@vega/auth";
import { ConfigurationToken } from "@vega/bootstrap";
import { MessageBoxService } from "@vega/dialog-utilities/message-box";
import { IdentityService, SigninSettings } from "@vega/identity";
import { TRANSLATE_SERVICE } from "@vega/localization";
import { of } from "rxjs";
import { map } from "rxjs/operators";

export const loginAuthGuard = authGuardWithActionFnFactory(() => {
    const identityService = inject(IdentityService);
    const configuration = inject(ConfigurationToken);
    const messageBoxService = inject(MessageBoxService);
    const translateServie = inject(TRANSLATE_SERVICE);

    return (authResult, _, routerSnapshot) => {
        if (!configuration.identityServerConfiguration.use) {
            return of(true);
        }
        if (authResult === AuthorizationResult.notLoggedIn) {
            const signinSettings = new SigninSettings();
            const redirectUrl = routerSnapshot.url;
            signinSettings.acrValues = configuration.identityServerConfiguration.acrValues;
            signinSettings.state = {
                redirectUrl
            };
            return identityService.signinRedirect(signinSettings).pipe(map(() => false));
        }

        if (authResult === AuthorizationResult.missingPolicy) {
            const message = translateServie.instant("SHARED.MISSING_POLICY.MESSAGE");
            const title = translateServie.instant("SHARED.MISSING_POLICY.TITLE");
            messageBoxService.show(message, title, "OK", "warning");
        }

        return of(authResult === AuthorizationResult.isAuthorized);
    };
});
